import { render, staticRenderFns } from "./leftTime.vue?vue&type=template&id=560d8556&scoped=true"
import script from "./leftTime.vue?vue&type=script&lang=js"
export * from "./leftTime.vue?vue&type=script&lang=js"
import style0 from "./leftTime.vue?vue&type=style&index=0&id=560d8556&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d8556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560d8556')) {
      api.createRecord('560d8556', component.options)
    } else {
      api.reload('560d8556', component.options)
    }
    module.hot.accept("./leftTime.vue?vue&type=template&id=560d8556&scoped=true", function () {
      api.rerender('560d8556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bidStake/components/leftTime.vue"
export default component.exports